const headers = {
  name: "Projects",
  navigate: {
    path: [
      {
        name: "Projects",
        path: "/app/projects",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
